import { useSlot } from '~/hooks';

export interface WithSlotProps {
  slot?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withSlot<T extends React.ComponentType<any>>(Component: T, defaultSlot?: string) {
  function SlotComponent(props: React.ComponentProps<T> & WithSlotProps) {
    const slotProps = useSlot(props as React.ComponentProps<T>, defaultSlot);

    if (!slotProps) return null;
    return <Component {...slotProps} />;
  }

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  SlotComponent.displayName = `WithSlot(${Component.displayName || Component.name || 'Component'})`;

  return SlotComponent;
}
